import { formatSharesNumeral, sharesToEnglishWords } from '../../share-certificate/composables/sharesWords';

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

function parseAmount(value: unknown): number {
  const n = Number(String(value ?? '').replace(/,/g, '').trim());
  return Number.isFinite(n) ? n : 0;
}

export function formatConsiderationNumeral(value: unknown): string {
  const n = parseAmount(value);
  if (n <= 0) return '';
  return formatSharesNumeral(n);
}

export function considerationToEnglishWords(value: unknown, currencyLabel?: string): string {
  const n = parseAmount(value);
  if (n <= 0) return '';
  const words = sharesToEnglishWords(Math.floor(n));
  const currency = trim(currencyLabel) || 'Dollars';
  return `${currency} ${words} Only`.trim();
}

export function syncConsiderationWordFields(input: {
  amount: unknown;
  currencyName?: string;
}): { considerationNumeral: string; considerationWords: string } {
  return {
    considerationNumeral: formatConsiderationNumeral(input.amount),
    considerationWords: considerationToEnglishWords(input.amount, input.currencyName),
  };
}
